import React from 'react';
import { I18nextProvider } from 'react-i18next';
import { Route, Router } from 'react-router-dom';
import { getI18nInstance } from '@I18N/i18n';
import asyncComponent from './asyncComponent';
import Home from '../pages/Home';
import history from '../history';

const Activity = asyncComponent(() => import(/* webpackChunkName: "list" */ '../pages/Activity'));
const UserProfile = asyncComponent(() => import(/* webpackChunkName: "a" */ '../pages/UserProfile'));
const Opportunity = asyncComponent(() => import(/* webpackChunkName: "b" */ '../pages/Opportunity'));
const ActivateEmailUser = asyncComponent(() => import(/* webpackChunkName: "b" */ '../pages/ActivateEmailUser'));

const webRoutes = () => (
  <I18nextProvider i18n={getI18nInstance()}>
    <Router history={history}>
      <div style={{ height: '100%' }}>
        <Route exact path='/' component={Home} />
        <Route path='/activity/:id' component={Activity} />
        <Route path='/userProfile/:id' component={UserProfile} />
        <Route path='/opportunity/:id' component={Opportunity} />
        <Route path='/activateEmail/:aId' component={ActivateEmailUser} />
      </div>
    </Router>
  </I18nextProvider>
);

export default webRoutes;
